/*
* @author    Agence Dn'D <contact@dnd.fr>
* @license   https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link      https://www.dnd.fr/
*/

(() => {
    if (window.quickAddInit) return;
    window.quickAddInit = true;

    const getQuickAddVariants = (card) => {
        const script = card.querySelector('.js-quick-add-variants');
        return script ? JSON.parse(script.textContent) : null;
    };

    let swatchTooltipEl = null;

    const getSwatchTooltip = () => {
        if (!swatchTooltipEl) {
            swatchTooltipEl = document.createElement('div');
            swatchTooltipEl.className = 'product-block-options__swatch-tooltip';
            document.body.appendChild(swatchTooltipEl);
        }
        return swatchTooltipEl;
    };

    const showSwatchTooltip = (swatch) => {
        const text = swatch.dataset.optionItem;
        if (!text) return;

        const tooltip = getSwatchTooltip();
        tooltip.textContent = text;
        tooltip.classList.add('is-visible');

        const swatchRect = swatch.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        let left = swatchRect.left + swatchRect.width / 2 - tooltipRect.width / 2;

        const card = swatch.closest('product-block');
        if (card) {
            const cardRect = card.getBoundingClientRect();
            const minLeft = cardRect.left;
            const maxLeft = cardRect.right - tooltipRect.width;
            left = Math.min(Math.max(left, minLeft), maxLeft);
        }

        tooltip.style.top = `${swatchRect.top - tooltipRect.height - 6}px`;
        tooltip.style.left = `${left}px`;
    };

    const hideSwatchTooltip = () => {
        if (swatchTooltipEl) swatchTooltipEl.classList.remove('is-visible');
    };

    const updateVariantLinks = (card, variantId) => {
        card.querySelectorAll('.js-product-variant-link').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            link.href = `${url.pathname}${url.search}`;
        });
    };

    const updateVariantImage = (card, mediaId) => {
        const variantImages = card.querySelectorAll('.product-block__variant-image');
        if (!variantImages.length) return;

        let matched = null;
        variantImages.forEach((img) => {
            const isMatch = Boolean(mediaId) && img.dataset.mediaId === mediaId;
            img.classList.toggle('product-block__variant-image--active', isMatch);
            if (isMatch) matched = img;
        });

        const primaryImage = card.querySelector('.product-block__image--primary');
        if (primaryImage) primaryImage.classList.toggle('product-block__image--active', !matched);
    };

    const onSwatchSelect = (card, swatch, variants, idInput, addBtn, notifyLink) => {
        const {variantId} = swatch.dataset;
        const variant = variants[variantId];
        if (!variant) return;

        // Update hidden form input.
        idInput.value = variantId;

        // Keep PDP links (title, quick-buy, notify-me) pointed at the selected variant.
        updateVariantLinks(card, variantId);

        // Swap the product image for the one tied to this swatch, if any.
        updateVariantImage(card, swatch.dataset.media);

        // Update the persistent variant name under the title.
        const variantNameEl = card.querySelector('.js-product-variant-name');
        if (variantNameEl) variantNameEl.textContent = swatch.dataset.optionItem;

        // Update ARIA state across the radiogroup.
        const radiogroup = swatch.closest('[role="radiogroup"]');
        if (radiogroup) {
            radiogroup.querySelectorAll('[role="radio"]').forEach((el) => {
                el.setAttribute('aria-checked', el === swatch ? 'true' : 'false');
            });
        }

        // Update price inside the button.
        const priceCurrentEl = addBtn.querySelector('.price__current');
        const priceWasEl = addBtn.querySelector('.price__was');
        const priceEl = addBtn.querySelector('.price');
        if (priceCurrentEl) priceCurrentEl.innerHTML = variant.price;
        if (priceWasEl) priceWasEl.innerHTML = variant.compareAtPrice;
        if (priceEl) priceEl.classList.toggle('price--on-sale', Boolean(variant.compareAtPrice));

        // Toggle add-to-cart vs notify-me.
        addBtn.classList.toggle('hidden', !variant.available);
        notifyLink.classList.toggle('hidden', variant.available);
    };

    const initCard = (card) => {
        if (card.dataset.quickAddInit) return;
        card.dataset.quickAddInit = 'true';

        const variants = getQuickAddVariants(card);
        if (!variants) return;

        const idInput = card.querySelector('.js-quick-add-variant-id');
        const addBtn = card.querySelector('.product-block__quick-add-btn:not(.product-block__quick-add-btn--notify)');
        const notifyLink = card.querySelector('.product-block__quick-add-btn--notify');
        if (!idInput || !addBtn || !notifyLink) return;

        card.querySelectorAll('[role="radio"][data-variant-id]').forEach((swatch) => {
            const selectVariant = () => onSwatchSelect(card, swatch, variants, idInput, addBtn, notifyLink);

            swatch.addEventListener('click', selectVariant);
            swatch.addEventListener('keydown', (evt) => {
                if (evt.key === 'Enter' || evt.key === ' ') {
                    evt.preventDefault();
                    selectVariant();
                }
            });

            swatch.addEventListener('mouseenter', () => showSwatchTooltip(swatch));
            swatch.addEventListener('mouseleave', hideSwatchTooltip);
            swatch.addEventListener('focus', () => showSwatchTooltip(swatch));
            swatch.addEventListener('blur', hideSwatchTooltip);
        });

        const swatchInner = card.querySelector('.product-block-options__inner');
        if (swatchInner) swatchInner.addEventListener('scroll', hideSwatchTooltip);
    };

    const initAll = (root) => {
        root.querySelectorAll('product-block').forEach(initCard);
    };

    initAll(document);

    // Re-init cards injected later (ajax filtering/pagination, cart drawer recs, etc.).
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;
                if (node.matches && node.matches('product-block')) {
                    initCard(node);
                } else if (node.querySelectorAll) {
                    initAll(node);
                }
            });
        });
    });
    observer.observe(document.body, {childList: true, subtree: true});
})();
